export class PricesDefinitions {
    static item: any = {
        mpo: 5,
        personality: 5,
        talents: 4,
        dit: 3,
        communication: 3,
        satellite: 2,
        perception_initial: 0,
        perception_subsequent: 0,
        iac: 2
    };
}
